import { MachineCardItem as PackageMachineCardItem } from "247factorynet-packages";
import machineFallbackImage from "../assets/machine-example.png";
import { useResolvedImageSrc } from "../utils/imageFallback";

const SafeMachineCardItem = ({ imageSrc, ...props }) => {
  const resolvedImageSrc = useResolvedImageSrc(imageSrc, machineFallbackImage);

  return <PackageMachineCardItem {...props} imageSrc={resolvedImageSrc} />;
};

export default SafeMachineCardItem;
